
<template>
  <div class="footer">
    <!-- <DisplayProduct /> -->
    <div
      class="mic-animate"
      v-bind:class="{ 'start-animate': micOn }"
      @click="startSpeaking()"
      onclick="play()"
      v-if="this.$route.path !== '/' && this.$route.path !== '/login'"
    >
      <!-- <span class="user-speach">{{speak}}</span> -->

      <img src="@/assets/DarkTechMicSvg_4_5animated.svg" class="mic" />
    </div>

    <p class="copyright">Cogneetiv © 2020</p>
    <div class="text-center">
      <v-dialog v-model="dialog" width="850px">
        <v-card class="cardColor">
          <v-card-text>
            <div class="headline lighten-2 info-contain" primary-title>
              <span class="txt-green">{{ speak }}</span>
            </div>
            <AnimationVisualizer />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="dialog = false">ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>



<script>
// import DisplayProduct from "@/components/DisplayProduct.vue";
import AnimationVisualizer from "@/components/AnimationVisualizer.vue";
import startAudio from "@/assets/audio/future-ping.wav";
import { bus } from "../main";
export default {
  name: "Footer",
  components: {
    AnimationVisualizer,
  },
  data: () => ({
    speak: "",
    micOn: false,
    dialog: false,
    formStart: false,
    userInfo: {},
  }),
  methods: {
    startSpeaking: function () {
      new Audio(startAudio).play();

      let instance = this;
      this.recognition.start();

      this.recognition.onstart = function () {
        instance.micOn = true;
      };

      this.recognition.onend = function () {
        instance.micOn = false;
      };

      this.recognition.onerror = function () {
        instance.micOn = false;
      };

      this.recognition.onresult = function (e) {
        let transcript = e.results[0][0].transcript.toLowerCase();
        instance.speak = transcript;

        if (
          transcript.indexOf("navigate") !== -1 ||
          transcript.indexOf("render") !== -1
        ) {
          if (transcript.indexOf("dashboard") !== -1) {
            instance.$router.push({ name: "dashboard" });
            this.formStart = false;

            return;
          } else if (transcript.indexOf("interface") !== -1) {
            instance.$router.push({ name: "interface" });
            this.formStart = false;

            return;
          } else if (transcript.indexOf("daily briefing") !== -1) {
            instance.$router.push({ name: "dailybriefing" });
            this.formStart = false;

            return;
          } else if (transcript.indexOf("decision tracker") !== -1) {
            instance.$router.push({ name: "decisiontracker" });
            this.formStart = false;

            return;
          } else if (transcript.indexOf("departments") !== -1) {
            instance.$router.push({ name: "departments" });
            this.formStart = false;

            return;
          } else if (transcript.indexOf("my agenda") !== -1) {
            instance.$router.push({ name: "dailyagenda" });
            this.formStart = false;

            return;
          } else if (transcript.indexOf("sales") !== -1) {
            instance.$router.push({ name: "sales" });
            this.formStart = false;

            return;
          } else if (transcript.indexOf("marketing") !== -1) {
            instance.$router.push({ name: "marketing" });
            this.formStart = false;

            return;
          } else if (transcript.indexOf("projects") !== -1) {
            instance.$router.push({ name: "projects" });
            this.formStart = false;
            return;
          } else if (transcript.indexOf("accounting") !== -1) {
            instance.$router.push({ name: "accounting" });
            this.formStart = false;
            return;
          } else if (transcript.indexOf("hr") !== -1) {
            instance.$router.push({ name: "hr" });
            this.formStart = false;
            return;
          } else if (transcript.indexOf("infrastructure") !== -1) {
            instance.$router.push({ name: "infrastructure" });
            this.formStart = false;
            return;
          } else if (transcript.indexOf("financials") !== -1) {
            instance.$router.push({ name: "financials" });
            this.formStart = false;
            return;
          } else if (transcript.indexOf("purchasing") !== -1) {
            instance.$router.push({ name: "purchasing" });
            this.formStart = false;
            return;
          } else if (transcript.indexOf("brand") !== -1) {
            instance.$router.push({ name: "brand" });
            this.formStart = false;
            return;
          } else if (transcript.indexOf("operations") !== -1) {
            instance.$router.push({ name: "operations" });
            this.formStart = false;
            return;
          } else if (transcript.indexOf("online") !== -1) {
            instance.$router.push({ name: "online" });
            this.formStart = false;

            return;
          } else if (transcript.indexOf("settings") !== -1) {
            instance.$router.push({ name: "settings" });
            this.formStart = false;
            return;
          } else if (transcript.indexOf("graphs") !== -1) {
            instance.$router.push({ name: "graphs" });
            this.formStart = false;
            return;
          }
        }

        if (transcript.indexOf("clear form") !== -1) {
          this.formStart = false;
        }

        if (!this.formStart) {
          //  Using "show" word for displaying dashboard content
          if (transcript.indexOf("briefing") !== -1) {
            bus.$emit("startbriefing");
          } else if (transcript.indexOf("review") !== -1) {
            Event.$emit("startreview");
          } else if (transcript.indexOf("marketing") !== -1) {
            Event.$emit("startmarketing");
          } else if (transcript.indexOf("sales") !== -1) {
            Event.$emit("startsales");
          } else if (transcript.indexOf("show") !== -1) {
            if (transcript.indexOf("graphs") !== -1) {
              instance.$router.push({ name: "graphs" });
              Event.$emit("graphs", { msg: transcript });
            } else if (transcript.indexOf("year") !== -1) {
              Event.$emit("graphs", { msg: "year" });
            } else if (transcript.indexOf("month") !== -1) {
              Event.$emit("graphs", { msg: "month" });
            } else {
              Event.$emit("command", { msg: transcript });
            }

            return;
          } else if (transcript.indexOf("stop") !== -1) {
            Event.$emit("stop");
            return;
          } else if (transcript.indexOf("read") !== -1) {
            Event.$emit("read");
            return;
          } else if (transcript.indexOf("locate") !== -1) {
            //  Using "locate" word for google map navigation content
            if (instance.$route.path !== "/forms") {
              instance.$router.push({ name: "map" });
              setTimeout(() => {
                Event.$emit("locate", { msg: transcript });
              }, 500);
            } else {
              Event.$emit("locate", { msg: transcript });
            }
            return;
          } else if (
            transcript.indexOf("weather") !== -1 ||
            transcript.indexOf("climate") !== -1
          ) {
            //  Using "weather" or "climate"  word for weather
            Event.$emit("weatherReport", { msg: transcript });
          } else if (transcript.indexOf("google") !== -1) {
            //  Using "google"  word for searching content
            window.open(
              "https://www.google.com/search?q=" +
                transcript.replace("google", ""),
              "_blank"
            );
          } else if (transcript.indexOf("go to") !== -1) {
            window.open(
              "https://www." + transcript.replace("go to", ""),
              "_blank"
            );
          } else if (transcript.indexOf("create") !== -1) {
            console.log("Create a Form", instance.$route.path);

            // you can change the form type here - for example it looks for the word create, inside this we can add types of form

            if (transcript.indexOf("form") !== -1) {
              if (instance.$route.path !== "/forms") {
                instance.$router.push({ name: "forms" });
                setTimeout(() => {
                  Event.$emit("openForm", { msg: transcript });
                }, 500);
              } else {
                Event.$emit("openForm", { msg: transcript });
              }
            } else if (transcript.indexOf("create") !== -1) {
              console.log("Create a Quote", instance.$route.path);

              if (instance.$route.path !== "/quotegenerator") {
                instance.$router.push({ name: "quotegenerator" }); // Invoice Route if you have created any new route
                setTimeout(() => {
                  Event.$emit("openForm", { msg: transcript });
                }, 500);
              } else {
                Event.$emit("openForm", { msg: transcript }); // It will Trigger this function in Quotegenerator
              }
            }

            this.formStart = true;
          } else {
            instance.alfred(transcript);
          }
        } else {
          console.log("form details");
          Event.$emit("formDetails", { msg: transcript });
          if (transcript === "verified") {
            this.formStart = false;
          }
        }
      };
    },

    readOutLoud: function (msg) {
      const speech = new SpeechSynthesisUtterance();
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.text = msg;
      window.speechSynthesis.speak(speech);
      this.speak = msg;
      let instance = this;
      speech.onend = function () {
        instance.startSpeaking();
      };
    },
    alfred: async function (msg) {
      let instance = this;
      const response = await fetch(
        // "http://localhost:5005/webhooks/rest/webhook",
        "http://www.cogneetiv.com/webhooks/rest/webhook",
        {
          method: "POST",
          body: JSON.stringify({ message: msg }), // string or object
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      if (!json[0].text) {
        instance.readOutLoud("I'm sorry, I didn't get that!!");
        instance.startSpeaking();
      }

      if (json[0].text.indexOf("COVID") != -1) {
        instance.$router.push({ name: "info" });
      }

      if (json[0].text == "Email Sent") {
        this.readOutLoud("What's the message");
      } else if (json[0].text.indexOf("send_mail:") == 0) {
        this.sendMail(json[0].text.slice(19));
      } else {
        if (msg.indexOf("price") !== -1) {
          instance.dialog = false;
          instance.dialog = true;
          Event.$emit("showProductDetails", { msg: json[0].text });
        } else if (json[0].text.indexOf("It's ") != -1) {
          let date = new Date();
          let hours = date.getHours();
          let minutes = date.getMinutes();
          let ampm = hours >= 12 ? "pm" : "am";
          hours = hours % 12;
          hours = hours ? hours : 12; // the hour '0' should be '12'
          minutes = minutes < 10 ? "0" + minutes : minutes;
          let strTime = hours + ":" + minutes + " " + ampm;
          instance.dialog = true;
          this.readOutLoud("It's " + strTime);
          return;
        } else {
          instance.readOutLoud(json[0].text);
        }
      }
    },
    sendMail(message) {
      this.userInfo = JSON.parse(localStorage.getItem("currentUser"));
      const encodedMail = btoa(
        [
          `Content-Type: multipart/mixed; boundary="foo_bar_baz"\r\n`,
          `MIME-Version: 1.0\r\n`,
          `To: john@macheenist.com\r\n`,
          `Subject: Cogneetiv AI Testing Mailer \r\n\r\n`,
          `--foo_bar_baz\r\n`,
          `Content-Type: text/plain; charset="UTF-8"\n`,
          `MIME-Version: 1.0\n`,
          `Content-Transfer-Encoding: 7bit\n`,
          `Hello There\n\n ${message} \r\n\r\n`,
          `\n\nRegards\n`,
          ` ${this.userInfo.Mt.Ed}\n`,
          `\n\nFrom Cogneetiv\n`,
          `--foo_bar_baz--`,
        ].join("")
      )
        .replace(/\+/g, "-")
        .replace(/\//g, "_");
      const request = window.gapi.client.gmail.users.messages.send({
        userId: "me",
        resource: {
          raw: encodedMail,
        },
      });
      request.execute(() => {
        console.log("Send Mail");
        this.readOutLoud("Email Sent");
        this.$swal(
          "Email Sent!",
          "Your email has been sent successfully!",
          "success"
        );
      });
    },
  },
  computed: {},
  mounted() {
    Event.$off("speakModeOn"); // add this to remove multiple event trigger
    Event.$on("speakModeOn", (data) => {
      console.log(data);
      this.startSpeaking();
    });
  },
  beforeMount() {
    this.SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    this.recognition = new window.webkitSpeechRecognition();
  },
  beforeDestroy() {
    Event.$off("speakModeOn");
  },
};
</script>

<style >
.user-speach {
  position: absolute;
  bottom: 700px;
  font-size: 20px;
  left: 55%;
  color: #fff;
}
.cardColor {
  background: rgba(48, 64, 87, 0.85) !important;
  border-color: white !important;
  color: #fff;
}
.info-contain {
  text-align: center;
}
.txt-green {
  color: #fff;
  font-size: 35px;
  margin-top: 80px;
  display: inline-block;
}

.footer {
  background: rgb(48, 64, 87);
}
.start-animate {
  animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.3);
  }
  100% {
    box-shadow: 0 0 0 35px rgba(0, 0, 0, 0);
  }
}

@keyframes shadow-pulse-big {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 70px rgba(0, 0, 0, 0);
  }
}
.footer {
  background: #33455f;
  width: 100%;
  height: 9vh;
  position: fixed;
  bottom: 0px;
  z-index: 10;
}
.mic {
  width: 80px;
  margin: 10px auto;
}

p.copyright {
  position: absolute;
  width: 100%;
  color: #fff;
  line-height: 10px;
  font-size: 0.7em;
  text-align: left;
  bottom: 0px;
  left: 20px;
}

.mic-animate {
  margin: -50px auto;
  width: 100px;
  height: 100px;
  font: 13px/130px "Barlow Semi Condensed", sans-serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #fff;
  text-align: center;
  background: rgb(51, 69, 95);
  border-radius: 50%;
  /* animation: shadow-pulse 1s infinite; */
  cursor: pointer;
}

@media only screen and (max-width: 600px) {
  p.copyright {
    position: absolute;
    width: 100%;
    color: #fff;
    line-height: 10px;
    font-size: 0.7em;
    text-align: center;
    bottom: 0px;
    left: 0px;
  }
}
</style>
